var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzureCardDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic_sync_azure_blob_card_disabled",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2-azure-card-disabled{fill:#c8c8c8}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_002---Source-_-Target---Drag-_-Drop_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#f5f5f5"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-2",
    transform: "translate(15.2 15.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.383 8.383H0V0h8.383z",
    className: "cls-2-azure-card-disabled"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.383 8.383H177V0h8.383v8.383z",
    className: "cls-2-azure-card-disabled",
    transform: "translate(-167.783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.383 185.383H0V177h8.383z",
    className: "cls-2-azure-card-disabled",
    transform: "translate(0 -167.783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.383 185.383H177V177h8.383v8.383z",
    className: "cls-2-azure-card-disabled",
    transform: "translate(-167.783 -167.783)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureCardDisabled);
export default __webpack_public_path__ + "static/media/azure-card-disabled.1080d3a6a04f48c32bee621cee5b899e.svg";
export { ForwardRef as ReactComponent };